import { useState, useContext, useEffect } from "react"
import { CMultiSelect, CToggle, ReportSelectPeriod, TablePage, toast, CheckPermission, CSkeletonTable, ModalDelete, TablePagination, CModal, ModalFilterUser } from "../../../components/widget"
import { ContextNav, ContextAbsence, ContextLoading, ContextDashboard } from "../../../context";
import { VcationReasonsApi, DeleteVcationReasonsApi } from "../../../api";
import { Link } from 'react-router-dom'

export const VcationReasons = () => {
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const CtxDash = useContext(ContextDashboard)
    const [visibleDelete, setVisibleDelete] = useState<boolean>(false)
    const [selectDelete, setSelectDelete] = useState<any>(null)
    const [tableData, setTableData] = useState<any>([])
    const col: any = [
        {
            title: "علت مرخصی",
            render: (i: any) => (<>{i.title && i.title != null && i.title}</>)
        },
        {
            title: "اقدامات",
            render: (i: any) => (
                <div className="flex items-center w-full justify-around ">
                    {CheckPermission(60) &&
                        <Link to={`/p/settings/vacation-reasons/${i.id}`}>
                            <img src="/assetes/svg/edit.svg" className="w-[20px] cursor-pointer" />
                        </Link>
                    }
                    {CheckPermission(61) &&
                        <img src="/assetes/svg/trash.svg" onClick={() => startDelete(i.id)} className="w-[20px] cursor-pointer" />
                    }
                </div>)
        },

    ]

    const startDelete = (id: any) => {
        setSelectDelete(id)
        setVisibleDelete(true)
    }

    const DeleteRoll = async () => {
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await DeleteVcationReasonsApi(selectDelete)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast("با موفقیت حذف گردید", { type: "success" })
            setSelectDelete(null)
            setVisibleDelete(false)
            getData()
        }
        else {
            toast("خطایی رخ داده است", { type: "error" })
        }
    }



    const getData = async () => {
        try {
            CtxLoad.setDisplayLoadingSkelton(true)
            let res = await VcationReasonsApi()
            setTableData(res.data)
            CtxLoad.setDisplayLoadingSkelton(false)
        }
        catch (err: any) {
            CtxLoad.setDisplayLoadingSkelton(false)
        }
    }

    useEffect(() => {
        document.title = "علل مرخصی | دایان"
        CtxNav.setActiveMenuItem({ 'item': 3, 'subItem': 7, })
        getData()

    }, [])

    return (
        <div className=" w-full flex flex-col">

            <div className=" w-full flex md:flex-row flex-col items-center justify-between  mt-[7px] md:mt-[25px]">
                <h1 className="sm:text-2xl text-lg font-bold mb-[30px] md:mb-0">مدیریت علل مرخصی</h1>
                <div className=" w-full md:w-fit flex items-center md:mt-0 mt-[7px]">
                    {(CheckPermission(59) && CheckPermission(62)) ?
                        <button className=" w-full md:w-[150px] h-[30px] md:h-[40px] bg-dayan-gray-200 rounded-md md:text-sm text-[11px] text-white">
                            <Link to='/p/settings/vacation-reasons/add' className=" w-full h-full flex justify-center items-center">
                                + افزودن علت مرخصی
                            </Link>
                        </button>
                        :
                        <div />
                    }
                </div>
            </div>

            {CheckPermission(59) &&
                <div className=" w-full mt-[20px]">
                    {CtxLoad.displayLoadingSkelton == false ?
                        <TablePage columns={col} data={tableData} />
                        :
                        <CSkeletonTable />
                    }
                </div>
            }

            <ModalDelete visible={visibleDelete} setVisible={setVisibleDelete} onOk={DeleteRoll} loading={CtxLoad.displayLoadingBtn} />

        </div>
    )
}
